// extracted by mini-css-extract-plugin
export default {"table_container":"TransferHistoryView_table_container__87g8E"};